export default "__VITE_ASSET__Dp3Ie$2a__"